module.exports = __webpack_public_path__ + "img/decosummit-event.b1428576.png";